import '@eg-maps/commons';
import { buildIcon } from './uitk-eg-map-helper.esm.js';
import { UitkEGMapsUitkIconType, UitkEGMapsQualifier } from '../types/uitk-eg-map-marker-type.esm.js';

var extractRGBA = function (color) {
    if (color) {
        if (color.startsWith('#'))
            return { rgb: color, alpha: 1.0 };
        if (color.startsWith('rgb('))
            return { rgb: color, alpha: 1.0 };
        if (color.startsWith('rgba(')) {
            var _a = /rgba\(([0-9, ]*),[ ]*([0-9.]*)[ ]*\)/.exec(color) || [], rgb = _a[1], alpha = _a[2];
            if (rgb)
                return { rgb: "rgb(".concat(rgb, ")"), alpha: parseFloat(alpha) };
        }
    }
    return { rgb: color, alpha: 1.0 };
};
var primaryIconClass = 'uitk-eg-maps-primary-icon';
var secondaryIconClass = 'uitk-eg-maps-secondary-icon';
var DEFAULT_FONT_SIZE = '16px';
var convertRemToPixels = function (rem) { var _a; return parseFloat(rem) * parseFloat(((_a = getComputedStyle(document.documentElement)) === null || _a === void 0 ? void 0 : _a.fontSize) || DEFAULT_FONT_SIZE); };
var defaultEGMapsConfig = function (brand, getCssValue) {
    var _a, _b, _c, _d, _e;
    var _f, _g, _h;
    var routeColor = extractRGBA((_f = getCssValue('--uitk-map__route__border_color')) === null || _f === void 0 ? void 0 : _f.trim());
    var routeBorder = getCssValue('--uitk-map__route__border_width').trim();
    var routeBorderPixels = routeBorder.includes('rem') ? convertRemToPixels(routeBorder) : routeBorder;
    var routeSize = typeof routeBorderPixels === 'string' ? parseInt(routeBorderPixels, 10) : routeBorderPixels;
    var obfuscateAreaFillColor = extractRGBA((_g = getCssValue('--uitk-map__obfuscate_fill_color')) === null || _g === void 0 ? void 0 : _g.trim());
    var obfuscateAreaLineColor = extractRGBA((_h = getCssValue('--uitk-map__obfuscate_line_color')) === null || _h === void 0 ? void 0 : _h.trim());
    var obfuscateAreaLineWeight = parseInt(getCssValue('background-position-x'), 10);
    var soldOutIcon = buildIcon(UitkEGMapsUitkIconType.SOLD_OUT, primaryIconClass, brand);
    var mapConfig = {
        markers: {
            property: {
                show: {
                    default: true,
                    available: true,
                    filtered: true,
                    sold_out: true,
                    unknown: true
                },
                markerType: (_a = {
                        sold_out: 'pin',
                        available: 'price'
                    },
                    _a[UitkEGMapsQualifier.CRUISE] = 'text',
                    _a[UitkEGMapsQualifier.OBFUSCATED] = 'obfuscate',
                    _a[UitkEGMapsQualifier.OBFUSCATED_PIN] = 'pinObfuscate',
                    _a[UitkEGMapsQualifier.OBFUSCATED_PRICE] = 'priceObfuscate',
                    _a[UitkEGMapsQualifier.HOTEL] = 'pin',
                    _a[UitkEGMapsQualifier.VACATION_RENTAL] = 'pin',
                    _a[UitkEGMapsQualifier.ACTIVITY] = 'pin',
                    _a[UitkEGMapsQualifier.CAR] = 'pin',
                    _a[UitkEGMapsQualifier.AIRPORT] = 'pin',
                    _a),
                icons: (_b = {
                        hl: null,
                        available: null,
                        default: buildIcon(UitkEGMapsUitkIconType.HOTEL, primaryIconClass, brand)
                    },
                    _b["".concat(UitkEGMapsQualifier.HOTEL, "#sold_out")] = soldOutIcon,
                    _b["".concat(UitkEGMapsQualifier.CAR, "#sold_out")] = soldOutIcon,
                    _b["".concat(UitkEGMapsQualifier.VACATION_RENTAL, "#sold_out")] = soldOutIcon,
                    _b["".concat(UitkEGMapsQualifier.OBFUSCATED_PIN, "#sold_out")] = soldOutIcon,
                    _b["".concat(UitkEGMapsQualifier.AIRPORT, "#sold_out")] = soldOutIcon,
                    _b["".concat(UitkEGMapsQualifier.ACTIVITY, "#sold_out")] = soldOutIcon,
                    _b.sold_out = soldOutIcon,
                    _b[UitkEGMapsQualifier.HOTEL] = buildIcon(UitkEGMapsUitkIconType.HOTEL, primaryIconClass, brand),
                    _b[UitkEGMapsQualifier.CAR] = buildIcon(UitkEGMapsUitkIconType.CAR, primaryIconClass, brand),
                    _b[UitkEGMapsQualifier.VACATION_RENTAL] = buildIcon(UitkEGMapsUitkIconType.VACATION_RENTAL, primaryIconClass, brand),
                    _b[UitkEGMapsQualifier.OBFUSCATED_PIN] = buildIcon(UitkEGMapsUitkIconType.HOTEL, primaryIconClass, brand),
                    _b[UitkEGMapsQualifier.AIRPORT] = buildIcon(UitkEGMapsUitkIconType.AIRPORT, primaryIconClass, brand),
                    _b[UitkEGMapsQualifier.ACTIVITY] = buildIcon(UitkEGMapsUitkIconType.ACTIVITY, primaryIconClass, brand),
                    _b),
                cornerIcons: {
                    topRight: (_c = {},
                        _c[UitkEGMapsQualifier.SAVED] = buildIcon(UitkEGMapsUitkIconType.SAVED, secondaryIconClass, brand),
                        _c)
                },
                minZoomForDisplay: {
                    default: -1
                },
                clustering: {
                    default: {
                        type: 'supercluster',
                        excludedQualifiers: [UitkEGMapsQualifier.NOT_CLUSTERED],
                        superclusterSettings: {
                            radius: 105
                        },
                        maxZoom: 15,
                        minPoints: 10
                    }
                },
                obfuscateMarkers: {
                    radiusInM: {
                        default: 1000
                    },
                    style: {
                        default: {
                            line: {
                                weight: obfuscateAreaLineWeight,
                                color: obfuscateAreaLineColor.rgb,
                                opacity: obfuscateAreaLineColor.alpha
                            },
                            fill: {
                                color: obfuscateAreaFillColor.rgb,
                                opacity: obfuscateAreaFillColor.alpha
                            }
                        },
                        hl: {
                            line: {
                                weight: obfuscateAreaLineWeight,
                                color: obfuscateAreaLineColor.rgb,
                                opacity: obfuscateAreaLineColor.alpha
                            },
                            fill: {
                                color: obfuscateAreaFillColor.rgb,
                                opacity: obfuscateAreaFillColor.alpha
                            }
                        }
                    }
                }
            },
            place: {
                show: {
                    default: true,
                    unknown: true
                },
                markerType: {
                    default: 'pin'
                },
                minZoomForDisplay: {
                    default: -1
                },
                threshold: {
                    default: 1000
                },
                icons: (_d = {
                        default: buildIcon(UitkEGMapsUitkIconType.POI, primaryIconClass, brand),
                        unknown: null,
                        hl: null
                    },
                    _d[UitkEGMapsQualifier.AIRPORT] = buildIcon(UitkEGMapsUitkIconType.AIRPORT, primaryIconClass, brand),
                    _d[UitkEGMapsQualifier.RESTAURANT] = buildIcon(UitkEGMapsUitkIconType.RESTAURANT, primaryIconClass, brand),
                    _d[UitkEGMapsQualifier.CAR] = buildIcon(UitkEGMapsUitkIconType.CAR, primaryIconClass, brand),
                    _d[UitkEGMapsQualifier.TRANSIT] = buildIcon(UitkEGMapsUitkIconType.TRANSIT, primaryIconClass, brand),
                    _d[UitkEGMapsQualifier.GROCERY] = buildIcon(UitkEGMapsUitkIconType.GROCERY, primaryIconClass, brand),
                    _d[UitkEGMapsQualifier.TRANSPORTATION] = buildIcon(UitkEGMapsUitkIconType.TRANSPORTATION, primaryIconClass, brand),
                    _d[UitkEGMapsQualifier.METRO_STATION] = buildIcon(UitkEGMapsUitkIconType.METRO_STATION, primaryIconClass, brand),
                    _d[UitkEGMapsQualifier.BUS_STATION] = buildIcon(UitkEGMapsUitkIconType.BUS_STATION, primaryIconClass, brand),
                    _d[UitkEGMapsQualifier.PARKING] = buildIcon(UitkEGMapsUitkIconType.PARKING, primaryIconClass, brand),
                    _d[UitkEGMapsQualifier.PEOPLE] = buildIcon(UitkEGMapsUitkIconType.PEOPLE, primaryIconClass, brand),
                    _d[UitkEGMapsQualifier.ACTIVITY] = buildIcon(UitkEGMapsUitkIconType.ACTIVITY, primaryIconClass, brand),
                    _d),
                cornerIcons: {
                    topRight: (_e = {},
                        _e[UitkEGMapsQualifier.SAVED] = buildIcon(UitkEGMapsUitkIconType.SAVED, secondaryIconClass, brand),
                        _e)
                }
            }
        },
        routes: {
            style: {
                driving: {
                    lineStyle: 'normal',
                    color: routeColor.rgb,
                    width: routeSize,
                    opacity: routeColor.alpha
                },
                cycling: {
                    lineStyle: 'normal',
                    color: routeColor.rgb,
                    width: routeSize,
                    opacity: routeColor.alpha
                },
                walking: {
                    lineStyle: 'normal',
                    color: routeColor.rgb,
                    width: routeSize,
                    opacity: routeColor.alpha
                },
                flying: {
                    color: routeColor.rgb,
                    opacity: routeColor.alpha
                }
            }
        }
    };
    return mapConfig;
};

export { defaultEGMapsConfig, extractRGBA };
